import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_simple_text_question = _resolveComponent("quiz-simple-text-question");
  return _ctx.quiz?.questions?.length ? (_openBlock(), _createBlock(_component_quiz_simple_text_question, {
    key: 0,
    question: _ctx.quiz.questions[0],
    answer: _ctx.userAnswer,
    "answer-label": _ctx.isResultMode ? _ctx.$t('view.speach.openQuestion.answerLabel') : _ctx.$t('view.speach.openQuestion.answerInputLabel'),
    "is-result-mode": _ctx.isResultMode,
    "input-type": "textarea",
    onAnswerChange: _ctx.onAnswerChange
  }, null, 8, ["question", "answer", "answer-label", "is-result-mode", "onAnswerChange"])) : _createCommentVNode("", true);
}